<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane
        :label="$l('tab_pane_label_to_be_reviewed') || '待审核'"
        lazy
      >
        <ToBeReviewTable />
      </el-tab-pane>
      <el-tab-pane :label="$l('tab_pane_label_reviewed') || '已审核'" lazy>
        <beReviewTable />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ToBeReviewTable from './components/toBeReview-table'
import beReviewTable from './components/beReview-table'
export default {
  name: 'transport-shipmentPayStatementReview',
  components: { ToBeReviewTable, beReviewTable },
}
</script>
